import React, { useState } from 'react';
import './LevelsTableSection.css';
import { LevelAnchors } from './LevelAnchors';
import { MobileTables } from './MobileTables';
import { DesktopTable } from './DesktopTable';
import { useScreenWidthLessHook } from '../../../../shared/src/hooks/use-screen-width-less.hook';

export const LevelsTableSection = ({
    tableRows,
    tableColors,
    loyaltyLevels,
}) => {
    const [isMobileView, setIsMobileView] = useState(null);
    useScreenWidthLessHook({
        setIsWindowWidthLess: setIsMobileView
    });
    const sectionStyles = {
        '--level-text-color': tableColors?.levelText,
        '--cell-bg-color': tableColors?.bg,
        '--cell-text-color': tableColors?.text,
        '--cell-border-color': tableColors?.border,
    };

    return <div className="loyalty-levels-table__wrapper" style={sectionStyles}>
        {isMobileView && <LevelAnchors loyaltyLevels={loyaltyLevels} />}
        {isMobileView && <MobileTables tableRows={tableRows} loyaltyLevels={loyaltyLevels} />}

        {!isMobileView && <DesktopTable tableRows={tableRows} loyaltyLevels={loyaltyLevels} />}
    </div>;
};
